// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { Tabs, privileges, itemList, MultySelect } from "@lifepay/rc-ui-toolkit";
import { startOfYesterday, endOfToday } from "date-fns";

// import Input from "@lifepay/rc-ui-toolkit/dist-modules/controls/Input";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
// import actions from "model/actions";
import selectors from "model/selectors";
import queryFactory, {
  cardsForClient,
  cardTransactions,
} from "model/gql/queries";
import Transaction, {
  TransactionHeader,
} from "components/list-items/Transaction";

import Cards from "../Emission/Cards";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./Emission.m.scss";

const TransactionsData = itemList.QueryFactory(cardTransactions);
const CardsData = queryFactory(cardsForClient);

@withRouter
@privileges.withPrivileges
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      selectedPerson: selectors.clients.selectedPerson$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {}
)
@themr("emission", styles)
export default class Emission extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    selectedPerson: PropTypes.object,
    basePath: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { theme, selectedPerson, basePath, match, history } = this.props;
    const route = match.params.subdir;
    let activeTab = null;
    switch (route) {
      case "cards": {
        activeTab = "cards";
        break;
      }
      case "transactions": {
        activeTab = "TRANSACTIONS";
        break;
      }
      default: {
        activeTab = "cards";
      }
    }

    return selectedPerson && selectedPerson.type === "PERSON" ? (
      <div className={classnames(theme.wrapper)}>
        <CardsData clientId={selectedPerson.remoteId}>
          {({ data, loaded }) => {
            return (
              <Tabs
                activeTab={activeTab}
                tabs={[
                  {
                    id: "cards",
                    component: "Банковские карты",
                    onClick: () => {
                      history.push(`${basePath}/cards`);
                    },
                  },
                  {
                    id: "TRANSACTIONS",
                    component: "Транзакции",
                    onClick: () => {
                      history.push(`${basePath}/transactions`);
                    },
                  },
                ]}
              >
                {({ activeTab }) => {
                  switch (activeTab) {
                    case "cards": {
                      return (
                        <Cards
                          clientId={selectedPerson.remoteId}
                          cardsData={data}
                          cardsLoaded={loaded}
                        />
                      );
                    }
                    case "TRANSACTIONS": {
                      return (
                        <itemList.List
                          key={"TRANSACTIONS"}
                          useDataComponent
                          history={history}
                          location={location}
                          dataComponent={TransactionsData}
                          loadInitially={false}
                          filtersConfig={[
                            {
                              key: "dates",
                              type: "date-range",
                              default: {
                                startDate: startOfYesterday(),
                                endDate: endOfToday(),
                              },
                              required: true,
                              requiredMessage: "Введите даты",
                            },
                            {
                              key: "sortById",
                              label: "Сортировать по id",
                              type: "select",
                              hidden: true,
                              options: {
                                placeholder: "По умолчанию",
                                chooseAllName: "По умолчанию",
                                options: [
                                  { value: "ASC", label: "По возрастанию" },
                                  { value: "DSC", label: "По убыванию" },
                                ],
                              },
                            },
                            {
                              key: "sortByDate",
                              label: "Сортировать по дате",
                              type: "select",
                              hidden: true,
                              options: {
                                placeholder: "По умолчанию",
                                chooseAllName: "По умолчанию",
                                options: [
                                  { value: "ASC", label: "Самые старые" },
                                  { value: "DSC", label: "Самые новые" },
                                ],
                              },
                            },
                            {
                              key: "isSuccessful",
                              label: "Статус",
                              type: "select",
                              numeric: true,
                              options: {
                                placeholder: "Все",
                                chooseAllName: "Все",
                                options: [
                                  { value: 0, label: "Только неуспешные" },
                                  { value: 1, label: "Только успешные" },
                                ],
                              },
                            },
                            {
                              key: "transactionType",
                              label: "Тип транзакции",
                              type: "select",
                              numeric: true,
                              options: {
                                placeholder: "По всем типам",
                                chooseAllName: "По всем типам",
                                options: [
                                  { value: 0, label: "Отмены" },
                                  { value: 1, label: "Оплаты" },
                                  { value: 2, label: "Возвраты" },
                                  {
                                    value: 3,
                                    label: "Выдача",
                                  },
                                  {
                                    value: 4,
                                    label: "p2p",
                                  },
                                ],
                              },
                            },
                            {
                              key: "cardId",
                              label: "Карта",
                              type: "string",
                              required: true,
                              modifier: "double",
                              requiredMessage: "Выберите карту",
                              component: MultySelect,
                              default: undefined,
                              options: {
                                maxSelected: 1,
                                options:
                                  data && data.cards
                                    ? data.cards.map((card) => ({
                                        id: `${card.cardId}`,
                                        component: `${card.pan}`,
                                      }))
                                    : [],
                              },
                              inputFormatter: (value) => value[0],
                              valueFormatter: (value) => [value],
                            },
                          ]}
                        >
                          {(listProps) => (
                            <React.Fragment>
                              <itemList.Controls {...listProps} />
                              <itemList.Results
                                {...listProps}
                                usePaginator={true}
                                Header={TransactionHeader}
                                Item={Transaction}
                              />
                            </React.Fragment>
                          )}
                        </itemList.List>
                      );
                    }
                    default: {
                      return null;
                    }
                  }
                }}
              </Tabs>
            );
          }}
        </CardsData>
      </div>
    ) : (
      <Redirect to={`/client/search`} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/Emission/Emission.js